
export const quoteAccountFields = `
  id
  name
  status
  internalId
  type
  salesforceId
  sfAccountNumber
  channel
  pricebookId
  portalRegion
`;

export const quotesSummaryFields = `
  id
  name
  description
  status
  customerName
  opportunityId
  opportunityName
  opportunityDescription
  partnerId
  partnerName
  partnerContactId
  partnerContactName
  partnerContactEmail
  internalRepName
  internalRepEmail
  currencyIsoCode
  termMonths
  expirationDate
  referenceNumber
  orderType
  customerNotes
  internalNotes
  mainServiceType
  serviceTypes
  createdAt
  updatedAt
`;

export const contactFields = `
  id
  name
  firstName
  lastName
  address
  city
  state
  zip
  country
  email
  phoneNumber
  type
`;

export const locationFields = `
  id
  name
  description
  address
  address2
  city
  state
  zip
  country
  addressFull
  isMain
`;

export const totalFields = `
  annualTotal
  recurringTotal
  oneTimeTotal
  partnerTotalPrice
  partnerRevenue
  didsTotal
  e911Total
  directoryListingTotal
  tollFreeTotal
  callPathsTotal
  minutesTotal
`;

export const lineItemFields = `
  id
  description
  quantity
  unitPrice
  listPrice
  storedListPrice
  oneTimeTotal
  annualTotal
  recurringTotal
  partnerUnitPrice
  ${totalFields}
  locationId
  locationDescription
  pricebookEntryId
  productId
  serviceType
  category
  subType
  mrrType
  usageType
`;

export const lineItemSubProductFields = `
  id
  quoteLineItemId
  quantity
  listPrice
  partnerPrice
  totalPrice
  productId
  name
  pricebookEntryId
`;

export const lineItemDisplayFields = `
  id
  locationId
  pricebookEntryId
  lineItemId

  description
  unitPrice
  partnerPrice
  quantity
  ${totalFields}
`;


// QUOTE TODO: remove maybe?
export const partnerFields = `
  id
  name
  salesforceId

  privateLabelSite {
    id
    key
    logoUrl
    printableLogoUrl
    logoLinkUrl
  }
`;

export const internalRepFields = `
  id
  name
  email
  phoneNumber
`;

export const portingFields = `
  id
  quoteId
  locationId
  locationName
  locationDescription
  portingRequired
  portingContactEmail
  portingContactName
  portingContactPhoneNumber
  portingSignerContactEmail
  portingFormFillerEmail
  portingCcEmails
  numbers {
    did
    status
    losingCarrier {
      name
      spid
    }
  }
  status
  createdAt
  updatedAt
`;

export const customerAccountAddressFields = `
  id
  address
  city
  state
  stateCode
  zip
  country
  countryCode
`;

export const customerAccountFields = `
  id
  name
  dba

  partnerId
  partnerName

  revioId
  accountNumber

  canEdit

  languageCode

  contacts {
    ${contactFields}
  }

  locations {
    ${locationFields}
  }

  billingAddress {
    ${customerAccountAddressFields}
  }
`;

export const customerCpniPinFields = `
  id
  cpniPin
`;

export const pricebookFields = `
  id
  name

  pricebookEntries {
    id
    name
    productId
    code
    description
    subDescription
    type
    active
    isPackage
    hasIncludedKey
    subType
    mrrType
    usageType
    categoryId
    categoryName
    categoryKey
    serviceTypes
    mainServices
    availableOnPackages
    subProduct
    productCategory
    currencyIsoCode

    didCount
    e911Count
    directoryListingCount
    tollFreeCount
    callPathCount
    minutesCount
    maxIncludedDidCount
    maxIncludedE911Count
    maxIncludedDirectoryListingCount
    maxIncludedTollFreeCount
    maxIncludedCallPathCount
    maxIncludedMinutesCount

    retailPrice
    partnerPrice

    pp1
    pp12
    pp24
    pp36
    pp60

    rp1
    rp12
    rp24
    rp36
    rp60

    tieredPricing {
      start
      stop
      pp1
      pp12
      pp24
      pp36
      pp60

      rp1
      rp12
      rp24
      rp36
      rp60
    }

    setupFeeProductId
    disableQuantityEdit
  }
`;

const lineItemOverrideFields = `
  id
  locationId
  pricebookEntryId
  quantity
  unitPrice
  partnerPrice
`;


export const coreQuoteFields = `
  ${quotesSummaryFields}
  internationalCalling
  tollFreeUsageRate
  defaultMarginPercentage

  lineItems {
    ${lineItemFields}
  }

  lineItemSubProducts {
    ${lineItemSubProductFields}
  }

  lineItemOverrides {
    ${lineItemOverrideFields}
  }

  porting {
    ${portingFields}
  }

  canEdit

  customer {
    ${customerAccountFields}
  }

  partner {
    ${partnerFields}
  }

  customerContact {
    ${contactFields}
  }

  partnerContact {
    ${contactFields}
  }

  internalRep {
    ${internalRepFields}
  }

  quoteAccount {
    ${quoteAccountFields}
  }
`;
